import TireRow from 'pages/CatalogPage/DH/Tires/TireRow/TireRow';

export default TireRow;
